import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER MENU
export const getMenu = async (rolUser, idUser) => {
    const result = await PrivateInterceptor(`menu/${rolUser}/${idUser}`, 'GET');
    return result;

}

// OBTENER TODOS LOS MENUS
export const getMenus = async () => {
    const result = await PrivateInterceptor(`Base/IT/Menu`, 'GET');
    return result;
}

export const postMenu = async (body) => {
    console.log(body)
    const result = await PrivateInterceptor(`Base/IT/Menu/register`, 'POST', body);
    return result;
}


export const putActividadMenu = async (body) =>{
    console.log(body)
    const result = await PrivateInterceptor(`Base/IT/Menu/actividadMenu`, 'PUT', body);
    return result;
}

// OPTIENE LA INFORMACION DE UN MENU
export const getInfoMenu = async (IdMenu) => {
    const result = await PrivateInterceptor(`Base/IT/Menu/${IdMenu}`, 'GET');
    return result;
}